module.exports = __webpack_public_path__ + "static/media/3.979a1d2d.jpg";